export const getPreviewUrl = state => {
  var _state$preview;
  return (_state$preview = state.preview) === null || _state$preview === void 0 ? void 0 : _state$preview.previewUrl;
};
export const getPreviewDomain = state => {
  var _state$preview2, _state$iframes;
  //@ts-expect-error have it check CEUI state for previewDomain for now
  return ((_state$preview2 = state.preview) === null || _state$preview2 === void 0 ? void 0 : _state$preview2.previewDomain) || ((_state$iframes = state.iframes) === null || _state$iframes === void 0 ? void 0 : _state$iframes.previewDomain);
};
export const getPortalInstanceId = state => {
  var _state$preview3;
  return (_state$preview3 = state.preview) === null || _state$preview3 === void 0 ? void 0 : _state$preview3.portalInstanceId;
};
export const getPortalInstanceDomain = state => {
  var _state$preview4;
  return (_state$preview4 = state.preview) === null || _state$preview4 === void 0 ? void 0 : _state$preview4.portalInstanceDomain;
};
export const getPortalInstancePath = state => {
  var _state$preview5;
  return (_state$preview5 = state.preview) === null || _state$preview5 === void 0 ? void 0 : _state$preview5.portalInstancePath;
};